export const buildSicTableStyles = isDark => {
  const borderColor = isDark ? '#4a4f58' : '#c4c9d0';
  const cellBorder = `1px solid ${borderColor}`;

  return {
    borderColor,
    headerCell: {
      backgroundColor: isDark ? 'rgb(34 45 59)' : '#d8e2ef',
      color: isDark ? 'white' : '#000000',
      fontWeight: 'bold',
      fontSize: '0.75rem',
      border: cellBorder,
      padding: '6px 8px',
      textAlign: 'center',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap'
    },
    weekendHeaderCell: {
      backgroundColor: isDark ? '#2c3a4d' : '#c9d6e8'
    },
    bodyCell: {
      fontSize: '0.8rem',
      border: cellBorder,
      padding: '4px 8px',
      verticalAlign: 'middle',
      color: isDark ? 'white' : 'black'
    },
    zebraBackground: rowIndex =>
      rowIndex % 2 === 0
        ? isDark
          ? '#1e1e2f'
          : '#ffffff'
        : isDark
        ? '#262838'
        : 'aliceblue',
    sicRowCell: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      border: cellBorder,
      padding: '6px 8px',
      textAlign: 'center',
      verticalAlign: 'middle',
      backgroundColor: isDark ? '#2a3445' : '#eef2f8',
      color: isDark ? 'white' : 'black'
    },
    passColors: {
      backgroundColor: isDark ? 'rgba(0, 210, 122, 0.22)' : '#d4edda',
      color: isDark ? '#7ee2b8' : '#155724'
    },
    failColors: {
      backgroundColor: isDark ? 'rgba(230, 55, 87, 0.25)' : '#f8d7da',
      color: isDark ? '#f59fae' : '#721c24'
    }
  };
};

export const resultColors = (styles, isPassing) => {
  if (isPassing === null || isPassing === undefined) return {};
  return isPassing ? styles.passColors : styles.failColors;
};
